import script from "./Security.vue?vue&type=script&setup=true&lang=js"
export * from "./Security.vue?vue&type=script&setup=true&lang=js"

import "./Security.vue?vue&type=style&index=0&id=1b58e1ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b58e1ee"]])

export default __exports__